var toggleNewsFilters = function(obj){
    var target = $('.' + $(obj).data('target'));

      if ($(target).hasClass('show')) {
        $(target).removeClass('show');
        $(".filter-label").not($(obj).parent('.filter-label')).fadeTo('fast', 1);
        $(target).slideUp('fast');
        $('.filter-label').css("pointer-events", "auto");
        $(obj).parent('.filter-label').removeClass('show-change');
      } else {
        $('.filter-options').removeClass('show');
        $(target).toggleClass('show');
        $(".filter-label").not($(obj).parent('.filter-label')).fadeTo('fast', 0.2);
        $(obj).parent('.filter-label').fadeTo('fast', 1);
        $(target).slideDown('fast');
        $(obj).parent('.filter-label').addClass('show-change');
      }
};

if($('#newsroom-search').length > 0){
    
    var relatedArticles = $('.newsroom-container__featured .newsroom-article');
    var excludeUrls = '';
        if(relatedArticles){
        $.each(relatedArticles, function(){
            if(typeof this.href !== undefined){
                if(this.href.length > 0){
                    excludeUrls += this.href + ' ';
                }
            }
        })
    }
    
    const newsroomSearch = new Search.default({
    url: sharedConfig.url,
    collections: [collection],
    query: {
      value: '!nullquery',
      canBeChanged: true,
    },
    updateUrlOnSearch: false,
    sort: {
        type: 'dmetad',
    },
    additionalFBparams: {
        profile: '_default',
        remove_urls: excludeUrls,
    },
    pagination: {
        target: '.newsroom-container__load-more',
        loadMore: true,
        arrows: false,
        pages: 5,
    },
    results: {
        numRanks: 12,
    },
    facets: {
        target: '.newsroom-container__all-filters',
        items: facetlist
    },
    onNoResultsPageUpdate: () => {
        $('.newsroom-title__filter').hide();
        $('.newsroom-container__all-filters--list').hide();
        return 
    },
    onFiltersUpdate: () => {
        if($('.newsroom-container__all-filters--list').html().length > 5){
            $('.newsroom-title__filter').show();
            $('.newsroom-container__all-filters--list').show();
        }
    },
    templates: {
        articleTemplate: (fields) => {
            var img; var summary;
            if(fields.metaData.I === undefined){
                img = "";
                summary = fields.summary ? '<p class="newsroom-articles__intro">' + fields.summary.replace(/^(.{150}[^\s]*).*/, "$1") + '...</p>' : "";
            }
            else {
                img = `<img class="newsroom-articles__all-img" src="${fields.metaData.I}">`; 
                summary = "";
            }
            
            var tampstampToDate = function tampstampToDate(UNIX_timestamp) {
            var newDate = new Date(UNIX_timestamp),
                months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                year = newDate.getFullYear(),
                month = months[newDate.getMonth()],
                date = newDate.getDate(),
                time = date + ' ' + month + ' ' + year;
            return time;
            };
          return `
            <a href="${fields.clickTrackingUrl}" class="newsroom-article col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="newsroom-articles__regular">
                ${img}
                <div class="newsroom-articles__regular-content">
                    <h4>${fields.title}</h4>
                    <p class="newsroom-articles__date">${fields.metaData.articleDate}</p>
                    <p class="newsroom-articles__intro">${summary}</p>
                    <span class="newsroom-articles__read-more">Read more</span>
                    <span class="newsroom-articles__share" onclick="return false;"></span>
                </div>
                </div>
            </a>
          `;
        },
        loadMoreTemplate: (fields) => {
            return '<button id="search-loadmore" class="button button--blue newsroom-container__load-more">Load more</button>';
        },
        formTemplate: (search, query, inputId) => {
            return `
                <form class="newsroom-container__search__form">
                    <input type="text" id="${inputId}" name="query" placeholder="" value="" class="ui-autocomplete-input tt-input">
                    <input type="submit" class="button button--green newsroom-container__search-button" value="">
                </form>
            `
          },
          facetCheckbox: ({ name, label, categories, singleChoice }, activeFacets, h) => {
              
            var header = `<div class="filter-${name.toLowerCase()} filter-label"><p class="filter-label__text" value="" onclick="toggleNewsFilters(this);" data-target="filter-${name.toLowerCase()}__options">${label}</p></div>`;
            let headerHTML = '';
            
            let list = '';
            categories.forEach(function(cat){
               cat.values.forEach((item) => {
                    if(item.selected == false){
                    list += `<li>
                            <label for="${name}-${item.label}">
                                <input
                                type="checkbox"
                                ${item.checked}
                                value="${item.data}"
                                name="${item.label}"
                                id="${name}-${item.label}"
                                data-fparam="${encodeURI(item.queryStringParamName)}"
                                data-singlechoice="${singleChoice}"
                                />
                                ${item.label} (${item.count})
                            </label>
                            </li>`;
                    }
                });
            });

            return `${header}
                      <div class="filter-${name.toLowerCase()}__options filter-options checkbox-facet">
                          <ul>
                          ${list}
                          </ul>
                      </div>`;
          },
          activeFacet: (name, param) => {
              let header = '<h4 class="newsroom-title__filter">Active Facets</h4>';
              return `
                <span class="newsroom-container__all-filters__facet--active" param="${param}" name="${name}">
                  ${name}
                </span>
              `;
            },
            noResults: (query, spell) => {
              return `<div class="newsroom-articles--no-results">No matching articles</div>`;
            },
          
    }
    });
    newsroomSearch.init();    
    toggleNewsFilters();
    if($('#search-queryinput').val() == '!nullquery'){
        $('#search-queryinput').val('');
    }
}

if($('.related-articles').length > 0){
    var title = $('title').text().split('|')[0].trim();
    var metaQuery = '';
        $.each($('.article__filter-tags >  .fb-meta'),function(){
        metaQuery += this.innerText + '+';
    })
    const newsroomRelated = new Search.default({
        url: sharedConfig.url,
        collections: [collection],
        query: {
          value: '!"' + title + '"',
          canBeChanged: true,
        },
        sort: {
            type: 'relevance',
        },
        additionalFBparams: {
            profile: '_default',
            query_or: '' + metaQuery + '',
        },
        updateUrlOnSearch: false,
        results: {
            target: '.related-articles .newsroom-articles',
            numRanks: 4,
        },
        templates: {
            articleTemplate: (fields) => {
                var img; var summary;
                if(fields.metaData.I === undefined){
                    img = "";
                    summary = fields.summary ? '<p class="newsroom-articles__intro">' + fields.summary.replace(/^(.{150}[^\s]*).*/, "$1") + '...</p>' : "";
                }
                else {
                    img = `<img class="newsroom-articles__all-img" src="${fields.metaData.I}">`; 
                    summary = "";
                }
                var tampstampToDate = function tampstampToDate(UNIX_timestamp) {
                var newDate = new Date(UNIX_timestamp),
                    months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    year = newDate.getFullYear(),
                    month = months[newDate.getMonth()],
                    date = newDate.getDate(),
                    time = date + ' ' + month + ' ' + year;
                return time;
                };
              return `
                <a href="${fields.clickTrackingUrl}" class="newsroom-article col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="newsroom-articles__regular">
                    ${img}
                    <div class="newsroom-articles__regular-content">
                        <h4>${fields.title}</h4>
                        <p class="newsroom-articles__date">${fields.metaData.articleDate}</p>
                        <p class="newsroom-articles__intro">${summary}</p>
                        <span class="newsroom-articles__read-more">Read more</span>
                        <span class="newsroom-articles__share" onclick="return:false;"></span>
                    </div>
                    </div>
                </a>
              `;
            }
        }
    });
    newsroomRelated.init();
}
jQuery(document).ready(function(){
$(".newsroom-articles__share").on( "click", function() {
    let copyLink = $(this).parent().parent().parent('a').attr("href"); 
    $(".newsroom-articles__sharing-link > input").val(copyLink);
    let facebookUrl = "https://www.facebook.com/sharer/sharer.php?u=" + copyLink;
    let twitterUrl = "https://twitter.com/home?status=" + copyLink;
    let linkedinUrl = "https://www.linkedin.com/shareArticle?mini=true&url=" + copyLink;
    $(".newsroom-articles__sharing > .facebook").attr("href", facebookUrl);
    $(".newsroom-articles__sharing > .twitter").attr("href", twitterUrl);
    $(".newsroom-articles__sharing > .linkedin").attr("href", linkedinUrl);
}); 
});

$(".newsroom-articles__share").on("click", function() {
    $('.newsroom-articles__sharing-bg').removeClass('hidden');
    $('.newsroom-articles__sharing').removeClass('hidden');
});
$('.newsroom-articles__sharing-bg, .newsroom-articles__sharing-close').on("click", function() {
    $('.newsroom-articles__sharing-bg').addClass('hidden');
    $('.newsroom-articles__sharing').addClass('hidden');
});

$(function() {
	$('.copy-to-clipboard input').click(function() {
	$(this).focus();
	$(this).select();
    document.execCommand('copy');
	$(".copied").text("Copied to clipboard").show().fadeOut(1200);
    });
});